import React, { FC } from 'react';
import { LogInOut } from './LogInOut';
import { ReactComponent as Logo } from '../assets/outthink-logo.svg';
import styled from 'styled-components';
import { HeaderFooter } from './HeaderFooter';
export const HeaderBar: FC<{ className?: string }> = ({ className }) => (
    <Header className={className}>
        <div className="grid-content left-content">
            <a href="/">
                <Logo />
            </a>
        </div>
        <div className="grid-content center-content">
            <Heading>Command Center</Heading>
        </div>
        <div className="grid-content right-content">
            <LogInOut />
        </div>
    </Header>
);

const Heading = styled.h1`
    font-weight: normal;
    font-size: 160%;
`;

const Header = styled(HeaderFooter)`
    svg {
        fill: ${(props) => props.theme.colors.primary.color};
    }
`;
